/*
 * @Author: lvjinbin-at-631455864747 1367100043@qq.com
 * @Date: 2022-11-24 09:01:58
 * @LastEditors: lvjinbin-at-631455864747 1367100043@qq.com
 * @LastEditTime: 2025-08-14
 * @Description: http 配置 (兼容 Nuxt4/Vite)
 */

import http from "http";
import https from "https";

let httpAgent = null;
let httpsAgent = null;

if (process.server) {
  httpAgent = new http.Agent({ keepAlive: true });
  httpsAgent = new https.Agent({ keepAlive: true });
}

export default {
  // 超时设置 120s
  timeout: 1000 * 120,
  // 跨域是否带 Token
  withCredentials: true,
  // 响应的数据格式
  responseType: "json",
  // 仅服务端有效
  httpAgent,
  httpsAgent,
};
